import api from '@common/api';
import { UserInvestorRole } from '@services/appsync/types';
import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';

interface InvestorRolesModelProps {
  investorRoles?: UserInvestorRole[];
}
interface InvestorRolesModelActions {
  fetchMyInvestorRoles: () => Promise<UserInvestorRole[] | null>;
  getMyInvestorId: () => Promise<string | null>;
}

export const InvestorRolesModel = createStore(
  persist<InvestorRolesModelProps & InvestorRolesModelActions>(
    (set, get) => ({
      fetchMyInvestorRoles: async () => {
        const investorRoles = await api.allMyInvestorRoles();
        set({ investorRoles });
        return investorRoles;
      },
      getMyInvestorId: async () => {
        const roles = await get().fetchMyInvestorRoles();
        return roles && roles.length > 0 ? roles[0].investor_id : null;
      },
      investorRoles: [],
    }),
    {
      getStorage: () => localStorage,
      name: 'investorRoles-model',
    },
  ),
);

export function useInvestorRolesModel(): InvestorRolesModelProps & InvestorRolesModelActions;
export function useInvestorRolesModel<T>(
  selector: (state: InvestorRolesModelProps & InvestorRolesModelActions) => T,
  equals?: (a: T, b: T) => boolean,
): T;
export function useInvestorRolesModel<T>(
  selector?: (state: InvestorRolesModelProps & InvestorRolesModelActions) => T,
  equals?: (a: T, b: T) => boolean,
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(InvestorRolesModel, selector!, equals);
}
